var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { getMetricsByDimension } from "./getMetricsByDimension";

function getSeries(id, series) {

    var values = series.map(function (data) {
        return data.y;
    });

    var total = values.reduce(function (total, value) {
        return parseFloat(total) + parseFloat(value);
    });

    var average = total / series.length;

    return {
        id: id,
        total: total,
        average: average,
        data: series
    };
}

export function getMetricsByDimensionCompare(rows) {
    var byMetric = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ga:users";
    var byDimension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ga:date";


    if (!rows) {
        return false;
    }

    var metric = getMetricsByDimension(rows, byMetric, byDimension);
    var series = metric.data[0].data;

    var s1 = series.slice(0, series.length / 2);
    var s2 = series.slice(series.length / 2, series.length);

    var d2 = s2.map(function (row, i) {

        return _extends({}, row, {
            x: s1[i].x
        });
    });

    var primary = getSeries("primary", s1);
    var secondary = getSeries("secondary", d2);

    return _extends({}, metric, {
        "data": [primary, secondary]
    });
}